import React from 'react';
import { Card } from '../CommonComponents/OPL/Card/Card';
import { EmptyState } from '../CommonComponents/OPL/AsyncStates/EmptyState/EmptyState';

export const NewsfeedEmpty = () => (
  <Card p="48">
    <EmptyState variant="newspaper" message="Nothing to see here yet" />
  </Card>
);
